import { Component, Inject } from '@angular/core';

import { MatDialogRef, MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { PackagesPersoService } from 'src/services/packages-perso.service';
import { TranslateModule, TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'app-delete-package-perso-dialog',
    imports: [MatDialogModule, TranslateModule],
    templateUrl: './delete-package-perso-dialog.component.html'
})
export class DeletePackagePersoDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<DeletePackagePersoDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { packageId: number },
    private packagesPersoService: PackagesPersoService,
    private snackBar: MatSnackBar,
    private translateService: TranslateService
  ) { }

  confirmerSuppression(): void {
    this.packagesPersoService.deletePackage(this.data.packageId).subscribe({
      next: () => {
        this.translateService.get('PACKAGES_PERSO_MANAGEMENT.DELETION_SUCCESSFUL').subscribe(message => {
          this.snackBar.open(message, 'OK', { duration: 3000 });
        });
        this.dialogRef.close(true);
      },
      error: () => {
        this.translateService.get('PACKAGES_PERSO_MANAGEMENT.DELETION_ERROR').subscribe(message => {
          this.snackBar.open(message, 'OK', { duration: 3000 });
        });
        this.dialogRef.close(false);
      }
    });
  }

  annuler(): void {
    this.dialogRef.close(false);
  }
}
